<template>
  <div>
    <div v-if="isNew">Please select the survey location</div>
    <b-row align-h="end" class="text-left">
      <b-col>
        <b-form-select
          v-if="isNew"
          v-model="$v.selected.$model"
          :class="{ 'is-invalid': isInvalid }"
        >
          <option
            v-for="loc in locations"
            :key="loc.id"
            :value="{ locId: loc.id, locName: loc.name }"
          >{{ loc.name }}</option>
        </b-form-select>

        <div v-else>
          <b-form-input v-model="search" type="text" placeholder="Type a location name"></b-form-input>
          <b-table
            striped
            hover
            :items="filteredItems"
            :fields="fields"
            empty-text="No matching results"
          >
            <template slot="Add" slot-scope="row">
              <b-button @click.stop="setLocation2(row.item)">Add</b-button>
            </template>
          </b-table>
        </div>
      </b-col>
    </b-row>
    <span v-if="locations.length > 0">location found: {{ locations.length }}</span>
    <b-row v-if="locations.length == 0 && isLoading == false">
        <b-alert show variant="warning">No location available for today</b-alert>
    </b-row>
    <b-row>
      <b-col>
        <b-button
          :disabled="isInvalid"
          variant="primary"
          size="lg"
          @click="setLocation"
        >Set Location</b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import ajax from "@/resources/myApi.js";
import { userService } from "@/resources/UserService.js";

//import  ajax  from "@/resources/myApi.js";

export default {
  name: "survey-location",
  props: ["location", "isValid", "isNew"],
  data: () => ({
    search: "",
    selected: null,
    locationId: 0,
    locations: [],
    isInvalid: false,
    isLoading: false,
    items: [],
    fields: [
      {
        key: "locationName",
        sortable: true
      },
      {
        key: "locationDate",
        sortable: true
      },
      {
        key: "surveyCount",
        label: "# of Surveys",
        sortable: true
      },
      {
        key: "Add"
      }
    ]
  }),
  validations: {
    selected: {
      required
    }
  },
  methods: {
    setLocation() {
      if (this.$v.selected.required) this.$emit("set-location", this.selected);
      else this.isInvalid = true;
    },
    setLocation2(item) {
      this.$emit("set-location", {
        locId: item.locationId,
        locName: item.locationName
      });
    },
    onLoad() {
      console.log("onLoad");
      if (this.isNew) {
        this.isLoading = true;
        ajax
          .get("locations/active")
          .then(res => { 
            this.locations = res.data;
            this.isLoading = false;
            
           })
          .catch(error => { 
            console.log(error); 
            if(error.response !== undefined && error.response !== null && error.response.status === 401){
              userService.logOut();
            }
            this.isLoading = false;
            });
      } else {
        ajax
          .get("locations/fullhistory")
          .then(res => { 
            this.items = res.data;
            this.isLoading = false;
           } )
          .catch(error => console.log(error));
      }
    },
    handleResponse(arr) {
      let processedItems = [];
    }
  },
  computed: {
    filteredItems() {
      return this.items.filter(i => {
        return i.locationName.toLowerCase().includes(this.search.toLowerCase());
      });
    }
  },
  mounted() {
    this.onLoad();
  },
  created() {

    //this.onLoad();
  },

  watch: {
    selected() {
      if (this.selected.locId) this.isInvalid = false;
    }
  }
};
</script>

<style scoped>
.row {
  padding-bottom: 20px;
}
.card {
  min-width: 25%;
  margin: 10px;
}
</style>

